export default "__VITE_ASSET__DPl$mxls__"